import { LtiRequestType } from '../../Entities';
import { requestHandler } from '../../utils/api';

export type Lti1p3LaunchParams = {
  apiUrl: string;
  spaceId: string;
  clientId: string;
  type: LtiRequestType;
  userId: string;
  resourceLinkId?: string;
};

export const lti1p3Launch = async ({
  apiUrl,
  spaceId,
  clientId,
  type,
  userId,
  resourceLinkId,
}: Lti1p3LaunchParams): Promise<string> => {
  const {
    data: { ltiSessionToken },
  } = await requestHandler({
    url: `${apiUrl}/lti/1p3/start`,
    method: 'post',
    userId,
    data: {
      spaceId,
      clientId,
      type,
      resourceLinkId,
    },
  });

  return ltiSessionToken;
};
